<template>
  <vs-popup
    :title="this.title"
    :active="active"
    @close="close"
  >
    <div style="overflow-y: scroll">
      <div id="partner-invc-loading" class="p-2 vs-con-loading__container">
        <vs-table :data="invc.lineItems">
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Qty</vs-th>
            <vs-th>Price</vs-th>
            <vs-th>Total Price</vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody v-for="(item, index) in data" :key="index">
              <vs-tr>
                <vs-td :data="invc">{{ item.name }}</vs-td>
                <vs-td :data="invc">{{ item.quantity }}</vs-td>
                <vs-td :data="invc">${{ item.price }}</vs-td>
                <vs-td :data="invc">${{ item.totalPrice }}</vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <vs-list class="my-4">
          <vs-list-item title="Subtotal">${{ invc.subtotal }}</vs-list-item>
          <vs-list-item title="Shipping">${{ invc.shipping }}</vs-list-item>
          <vs-list-item title="Tax">${{ invc.tax }}</vs-list-item>
          <vs-list-item title="Total">${{ invc.total }}</vs-list-item>
        </vs-list>
        <vs-alert :active="billError" color="danger">
          {{ billError }}
        </vs-alert>
        <vs-col
          v-if="create"
          vs-type="flex"
          vs-justify="space-between"
          class="p-3"
        >
          <vs-input
            type="text"
            class="w-full mr-3"
            placeholder="Invoice Number"
            v-model="newInvcNumber"
          />
          <div>
            <vs-button @click="billNewInvc" :disabled="!newInvcNumber">
              Apply
            </vs-button>
          </div>
        </vs-col>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import http from '@/http/api'

const invcTemp = () => {
return {
    subtotal: 0,
    shipping: 0,
    tax: 0,
    total: 0,
    orderIds: [],
    lineItems: []
  }
}

export default {
  props: [
    'source',
    'invcNumber',
    'active',
    'create',
    'refreshInvcList'
  ],
  data() {
    return {
      title: '',
      invc: invcTemp(),
      newInvcNumber: null,
      billError: null
    }
  },
  watch: {
    active: {
      handler(v) {
        if (v && !this.create) this.getInvc()
        if (v && this.create) this.getNewInvc()
      }
    },
  },
  methods: {
    async getInvc() {
      this.showSpinnerOverCard();
      this.title = `${this.source ? this.source.toUpperCase() : ''} - ${this.invcNumber}`
      await http.getPartnerInvc(this.source, this.invcNumber).then(invc => this.invc = invc)
      this.hideSpinnerOverCard()
    },
    async getNewInvc() {
      this.showSpinnerOverCard();
      this.title = `${this.source ? this.source.toUpperCase() : ''} - Bill Orders`
      await http.getPartnerUnbilledInvc(this.source).then(invc => this.invc = invc)
      this.hideSpinnerOverCard()
    },
    async billNewInvc() {
      if (!this.newInvcNumber) return;

      this.billError = null;
      this.showSpinnerOverCard();
      const [error, success] = await http.billPartnerInvcs(this.source, this.invc.orderIds, this.newInvcNumber)

      if (!success) this.billError = error;
      else {
        await this.refreshInvcList()
        this.close()
      }

      this.hideSpinnerOverCard()
    },
    showSpinnerOverCard() {
      this.loading = true;
      this.$vs.loading({
        container: `#partner-invc-loading`,
        scale: 0.6
      });
    },
    hideSpinnerOverCard() {
      this.loading = false;
      this.$vs.loading.close(`#partner-invc-loading > .con-vs-loading`)
    },
    close() {
      this.invc = invcTemp();
      this.newInvcNumber = null;
      this.billError = null;
      this.$emit('update:active', false)
    }
  }
}
</script>
